/* (ignored) */


//////////////////
// WEBPACK FOOTER
// stream (ignored)
// module id = 3
// module chunks = main